/** Non-breaking space before `+N` overflow suffix (shared by React and HTML signal copy). */
export const SIGNAL_SELECTION_OVERFLOW_NBSP = "\u00A0";

/** Plain-text `+N` suffix for filter dropdown labels (no markup). */
export function formatSelectionOverflowSuffix(hiddenCount: number): string | null {
    if (hiddenCount <= 0) {
        return null;
    }

    return `${SIGNAL_SELECTION_OVERFLOW_NBSP}+${hiddenCount}`;
}

/** HTML `+N` suffix for signal name copy (`dangerouslySetInnerHTML`). */
export function formatSelectionOverflowHtml(hiddenCount: number): string {
    const suffix = formatSelectionOverflowSuffix(hiddenCount);

    return suffix ? `<b>${suffix}</b>` : "";
}
